// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__1vEi1","article__body":"Article_article__body__7jiTc"};